<template>
  <div id="app">
    <!-- HEADER -->
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <nav class="nav-secondary px-4">
      <!-- school logo goes here -->
      <img :src="`${publicPath}branding/logo.png`" width="190px" style="margin-left: -0.5rem;" alt="logo" srcset="">
      <!-- text resize goes here -->
      <img
        src="@/assets/img/_ui/svg/text-resize.svg"
        alt="resize text"
        srcset=""
        role="button"
        tabindex="0"
        @click="resizeText()"
      >
    </nav>
    <nav class="navbar navbar-custom navbar-expand-lg navbar-light px-4">
      <router-link
        class="navbar-brand d-none d-md-block"
        to="/"
      >on-campus employment toolkit for students</router-link>
      <router-link
        class="navbar-brand d-md-none text-start"
        to="/"
      >on-campus employment toolkit<br> for students</router-link>

      <!-- NAV CONTENT -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="show=!show"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        :class="[!show?'collapse':'']"
        class="navbar-collapse mobile"
        id="navbarNavDropdown"
      >
        <ul class="navbar-nav">
          <!-- JOB SEARCH -->
          <li
            class="nav-item dropdown"
            @click="show=!show"
          >
            <router-link
              to="/job-search"
              class="nav-link nav-link--green dropdown-toggle"
            >
              Job search
            </router-link>
            <!-- <a
              class="nav-link nav-link--green dropdown-toggle"
              href="#"
              id="jobSearchLink"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Job search
            </a> -->
            <ul
              class="dropdown-menu"
              aria-labelledby="jobSearchLink"
            >
              <li
                v-for="item in $store.state.jobSearch"
                :key="item.route"
              >
                <router-link
                  :to="`/job-search/${item.route}`"
                  class="dropdown-item"
                >
                  {{item.name}}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- INTERVIEW PREP -->
          <li
            class="nav-item dropdown"
            @click="show=!show"
          >
            <router-link
              to="/interview-prep"
              class="nav-link nav-link--blue dropdown-toggle"
            >
              Interview prep
            </router-link>
            <!-- <a
              class="nav-link nav-link--blue dropdown-toggle"
              href="#"
              id="interviewPrepLink"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Interview prep
            </a> -->
            <ul
              class="dropdown-menu"
              aria-labelledby="interviewPrepLink"
            >
              <li
                v-for="item in $store.state.interviewPrep"
                :key="item.route"
              >
                <router-link
                  :to="`/interview-prep/${item.route}`"
                  class="dropdown-item"
                >
                  {{item.name}}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- ON THE JOB SUCCESS -->
          <li
            class="nav-item dropdown"
            @click="show=!show"
          >
            <router-link
              to="/on-the-job-success"
              class="nav-link nav-link--purple dropdown-toggle"
            >
              On-the-job success
            </router-link>
            <!-- <a
              class="nav-link nav-link--purple dropdown-toggle"
              href="#"
              id="onTheJobSuccessLink"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              On-the-job success
            </a> -->
            <ul
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="onTheJobSuccessLink"
            >
              <li
                v-for="item in $store.state.onTheJobSuccess"
                :key="item.route"
              >
                <router-link
                  :to="`/on-the-job-success/${item.route}`"
                  class="dropdown-item"
                >
                  {{item.name}}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- FUTURE CAREER PLANNING -->
          <li
            class="nav-item dropdown"
            @click="show=!show"
          >
            <router-link
              to="/future-career-planning"
              class="nav-link nav-link--orange dropdown-toggle"
            >
              Future career planning
            </router-link>
            <!-- <a
              class="nav-link nav-link--orange dropdown-toggle"
              href="#"
              id="futureCareerPlanningLink"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Future career planning
            </a> -->
            <ul
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="futureCareerPlanningLink"
              style="right: 0; left: auto"
            >
              <li
                v-for="item in $store.state.futureCareerPlanning"
                :key="item.route"
              >
                <router-link
                  :to="`/future-career-planning/${item.route}`"
                  class="dropdown-item"
                >
                  {{item.name}}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>

    <!-- MAIN CONTENT -->
    <transition>
      <router-view />
    </transition>

    <!-- FOOTER -->
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      publicPath: process.env.BASE_URL,
      currentFontSize: 100,
      show: false,
      windowWidth: null,
      mobile: null
    }
  },
  created () {
    window.addEventListener('resize', this.checkScreen)
    this.checkScreen()
  },
  methods: {
    resizeText () {
      const body = document.getElementsByTagName('html')[0]
      this.currentFontSize += 20
      if (this.currentFontSize >= 160) {
        this.currentFontSize = 100
      }

      body.style.fontSize = `${this.currentFontSize}%`
    },
    close () {},
    checkScreen () {
      this.windowWidth = window.innerWidth
      if (this.windowWidth <= 992) {
        this.mobile = true
        return
      }
      this.mobile = false
      // return
    }
  }
}
</script>

<style lang="scss">
// Import Main .scss file
@import "./scss/main.scss";

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
